export var tojsslink = function tojsslink(name, link, id, featuredName) {
  return {
    value: {
      href: link,
      text: name,
      title: name,
      id: id,
      featuredName: featuredName
    }
  };
};